import React, { useEffect, useState } from "react";
import Breadcrumbs from "common/Breadcrumbs/Breadcrumbs";
import { P } from "common/P/P";
import { routeConstants } from "navigation/routeConstants";
import Pagination from "components/Pagination/Pagination";

import { serviceConfig } from "configs";
import axios from "axios";

import { ReactComponent as AvatarIcon } from "common/assets/icons/user.svg";
import BetweenCompanyTable from "components/BetweenCompanyTable.tsx/BetweenCompanyTable";

const breadcrumbItems = [
	{ label: "Edara-ara resminamalar", path: routeConstants.root.route },
	{ label: "Gelenler" },
];

const BetweenCompanyPage: React.FC = (): JSX.Element => {
	const userString = localStorage.getItem("user");
	const user = userString ? JSON.parse(userString) : null;

	const userId = user ? user?.user._id : ""; // Replace with actual user ID
	const userTypeId = user ? user?.user.userTypeId?._id : null;
	const numericUserTypeId = parseInt(userTypeId);
	const [currentPage, setCurrentPage] = useState(1);
	const [betweenCompanyLetters, setBetweenCompanyLetters] = useState([]);
	const [totalPages, setTotalPages] = useState(0);

	const itemsPerPage = 10;

	const fetchBetweenCompanyLetters = async () => {
		try {
			const response = await axios.get(
				`${serviceConfig.apiUrl}/company-letters/`
			);
			setBetweenCompanyLetters(response.data.data);
			setTotalPages(Math.ceil(response.data.data.length / itemsPerPage));
		} catch (error) {
			console.error("Error fetching Dih letters:", error);
		}
	};

	useEffect(() => {
		fetchBetweenCompanyLetters();
	}, []);

	const handleRowClick = (order: any) => {
		console.log("OPENED");
		// navigate(`/account/orders/${order._id}`);
	};

	return (
		<div className="grid grid-cols-1 gap-4">
			<div className="grid grid-cols-1 gap-4 px-6 py-3 place-items-end">
				{/* <LangIcon />
					<ThemeIcon />
					<div className="relative">
						<NotificationIcon />
						<div className="absolute top-[-5px] right-[-5px] grid px-[0.4rem] py-[0.1rem] rounded-full place-items-center place-content-center bg-redColor">
							<P size="t2" type="semibold" className="text-white">
								4
							</P>
						</div>
					</div> */}
				<div className="grid gap-3 grid-cols-maxTwo place-items-center">
					<div className="p-2 rounded-full bg-grayOne">
						<AvatarIcon />
					</div>
					<div className="grid">
						<P size="t1" type="medium">
							{user ? `${user.user.name.charAt(0)}.${user.user.sirname}` : ""}
						</P>
						<P size="t2" type="regular" className="text-grayTwo">
							{user ? user.user.userTypeId?.positionName : ""}
						</P>
					</div>
				</div>
			</div>
			<div className="grid grid-flow-row auto-rows-max pb-7 gap-6 px-6 min-h-[90vh]">
				<Breadcrumbs items={breadcrumbItems} />

				<div>
					<BetweenCompanyTable
						orders={betweenCompanyLetters}
						onRowClick={handleRowClick}
						type="bc"
					/>
					<div className="grid grid-cols-maxTwo place-content-between place-items-center py-[14px] px-[20px] border-x border-b border-strokeColor rounded-b-md">
						<P size="t2" type="regular" className="text-grayTwo">
							Jemi {betweenCompanyLetters.length} sany
						</P>
						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							onPageChange={setCurrentPage}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BetweenCompanyPage;
